import Section from '../Section';
import QuickAdd from '../global/QuickAdd';

export default class FeaturedCollection extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */

  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.handleProductCardDisplay();

    document.addEventListener('shopify:section:load', this.handleProductCardDisplay);
    window.addEventListener('resize', this.handleProductCardDisplay);

    Array.prototype.forEach.call(
      element.querySelectorAll('.shop-now-button, .quick-add-button-variants'),
      (shopNow) => {
        if (shopNow) {
          shopNow.addEventListener('click', this.handleShopNow);
        }
      },
    );
    this.quickAddButtons = new QuickAdd(theme, element);
    this.theme.addBadges(this.element, 1000);
  }

  handleProductCardDisplay = () => {
    const gridViewItems = this.element.querySelectorAll('.grid-view-item');

    gridViewItems.forEach((gridViewItem) => {
      const isMobile = this.isMobile();
      // @ts-ignore
      const gridItemWidth = gridViewItem.offsetWidth;

      // Quick shop display
      const quickAddContainer = gridViewItem.querySelector('.product-card-image--bottom-wrapper');
      const quickAddWrapper = gridViewItem.querySelector('.quick-add-wrapper');
      if (quickAddContainer && quickAddWrapper) {
        if (gridItemWidth < 250 && !isMobile) {
          quickAddContainer.classList.add('quick-add-container--small');
          quickAddWrapper.classList.add('quick-add-wrapper--small');
        } else if (gridItemWidth > 250 || isMobile) {
          quickAddContainer.classList.remove('quick-add-container--small');
          quickAddWrapper.classList.remove('quick-add-wrapper--small');
        }
      }

      // Small grid item width layout toggle
      if (gridItemWidth < 250) {
        gridViewItem.classList.add('grid-view-item--small');
      } else {
        gridViewItem.classList.remove('grid-view-item--small');
      }
    });
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
